export default __webpack_public_path__ + "static/media/unreleased4.f0537920.svg";